import { render } from "./UserRewardsKingdom.vue?vue&type=template&id=3b6964f8"
import script from "./UserRewardsKingdom.vue?vue&type=script&lang=js"
export * from "./UserRewardsKingdom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__